// API client for the Refresh Monitor (engineering DB-problem detection).
// Backend: GET /admin/delivery-status in the dashone monorepo (apps/api), which reads
// dws_pet_performance_refresh_summary and flags gaps in each workspace's refresh history.
// dashmote-admin only, cached 1h server-side. Mirrors fetchDashboardAvailability in authApi.js.
// Backend: the Refresh Monitor endpoints.
import { getApiUrl } from "../utils/envConfig";
import { makeAuthenticatedRequest } from "./authApi";

// Returns { items: DeliveryStatusItem[], global_max_refresh: string, expected_refresh: string }.
// Each item carries a server-computed `status` (ok | stale | gap | one_time) and the
// `need_auto_refresh` flag; expected_refresh is the month a monthly workspace should have
// by now (the staleness baseline). Pass { forceRefresh: true } to append ?force_refresh=true
// (bypass + refill the 1h cache).
export const fetchDeliveryStatus = async ({ forceRefresh = false } = {}) => {
  try {
    const qs = forceRefresh ? "?force_refresh=true" : "";
    return await makeAuthenticatedRequest(`${getApiUrl()}/admin/delivery-status${qs}`);
  } catch (error) {
    throw new Error("Failed fetching delivery status: " + error.message);
  }
};
